module.exports = __webpack_public_path__ + "media/images/country_flags/py-a8aa2f6eb01cb30c8c4c532c96ab28b7.png";